// extracted by mini-css-extract-plugin
export default {"gpa__logo":"GpaLogo_gpa__logo__Y5CAv"};